import type { PropertyStatus } from '../constants/propertyStatus'
import type { ActivePropertyFilters } from '../types/propertyTypes'

// Offerings query keys factory.
// Mutations invalidate via the factory only — never raw arrays.

export interface ListKey {
  status: PropertyStatus
  search: string
  filters: ActivePropertyFilters
}

export const offeringsKeys = {
  all: ['offerings'] as const,
  lists: () => [...offeringsKeys.all, 'list'] as const,
  list: (key: ListKey) => [...offeringsKeys.lists(), key] as const,
  filters: () => [...offeringsKeys.all, 'filters'] as const,
  filtersFor: (status: PropertyStatus) => [...offeringsKeys.filters(), status] as const,
}
